/*-------Bean Class for feedback, bug, comment, question, contact us ---- */
export class FeedbackContact {
  attachment: any;
  reset(): any {
    throw new Error("Method not implemented.");
  }
	name: String;
	eMail: String;
	message: String;
	subject: String;
	mobileNo: String;
	fax: String;
	url: String;
	address1: String;
	address2:String;
	contactFeedBackType: String;
	feedBackId: Number;
	images : Image [];

}
export class Image {

	imageName: String;
	imageId: String;
	path: string;
	imageMimeType: String;
	url: String;
	imageSize: String;
	resolution: String;
	file:File

} 

	
